<script setup>
import { computed } from "vue"

const props = defineProps({
  thread: {
    type: Object,
    required: true,
  },
})

const title = computed(() => props.thread.otherParticipants.map(p => (p.type === 'store' ? p.name : p.nick)).join(', '))

const computedHref = computed(() => {
  const participant = props.thread.participatingAs

  if (participant.type === 'user') {
    return route('account.inbox.threads.show', props.thread)
  } else if (participant.type === 'store') {
    return route('seller.stores.inbox.threads.show', [participant, props.thread])
  }

  return null
})
</script>

<template>
  <a
    :href="computedHref"
    class="flex items-center text-gray-700 hover:bg-indigo-50 p-3"
  >
    <div class="flex flex-col gap-1 text-sm">
      <div class="font-medium">{{ title }}</div>
      <div class="text-xs text-gray-500">{{ thread.preview }}</div>
    </div>
    <div class="flex-1 text-right ml-2 text-xs text-gray-400 whitespace-nowrap">{{ thread.lastMessageCreatedAt }}</div>
  </a>
</template>
